import React from "react";
import { ReactComponent as AmazonLogo } from "@/images/amazon_icon.svg";
import { ReactComponent as AmazonFreshLogo } from "@/images/amazon_fresh_icon.svg";
import { ReactComponent as WalmartLogo } from "@/images/walmart_icon.svg";
import { ReactComponent as FlipkartLogo } from "@/images/flipkart_icon.svg";
import { ReactComponent as MyntraLogo } from "@/images/myntra_icon.svg";
import { ReactComponent as NykaaLogo } from "@/images/nykaa_icon.svg";
import { ReactComponent as BlinkitLogo } from "@/images/blinkit_icon.svg";
import { ReactComponent as BigBasketLogo } from "@/images/bigbasket_icon.svg";
import { ReactComponent as DMartLogo } from "@/images/dmart_icon.svg";
import { ReactComponent as JioMartLogo } from "@/images/jiomart_icon.svg";
import { ReactComponent as SwiggyLogo } from "@/images/swiggy_icon.svg";
import { ReactComponent as CarrefourLogo } from "@/images/carrefour_icon.svg";
import { ReactComponent as PurplleLogo } from "@/images/purplle_icon.svg";
import { ReactComponent as NoonLogo } from "@/images/noon_icon.svg";
import { ReactComponent as NoonMinutesLogo } from "@/images/noon_minutes_icon.svg";
import { ReactComponent as ZeptoLogo } from "@/images/zepto_icon.svg";
import { ReactComponent as TakealotLogo } from "@/images/takealot_icon.svg";
import { ReactComponent as TalabatLogo } from "@/images/talabat_icon.svg";
import { ReactComponent as TiktokLogo } from "@/images/tiktok_icon.svg";
import { ReactComponent as ShopeeLogo } from "@/images/shopee_icon.svg";
import { ReactComponent as LazadaLogo } from "@/images/lazada_icon.svg";
import { ReactComponent as HepsiburadaLogo } from "@/images/hepsiburada_icon.svg";
import {
    ChannelIntegrationConfig,
    ChannelIntegrationAccountType,
    ClientIntegrationFormFields,
    Channels,
    ChannelName,
} from "@/ts/common-types";

export const CHANNEL_CONFIGS: Record<number, ChannelIntegrationConfig> = {
    1: {
        id: Channels.AMAZON,
        name: ChannelName.AMAZON,
        logo: React.createElement(AmazonLogo),
        color: "#E38400",
        accountTypes: [
            { type: ChannelIntegrationAccountType.Seller, enabled: true },
            { type: ChannelIntegrationAccountType.Vendor, enabled: true },
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: true,
    },
    32: {
        id: Channels.AMAZON_FRESH,
        name: ChannelName.AMAZON_FRESH,
        logo: React.createElement(AmazonFreshLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    28: {
        id: Channels.MYNTRA,
        name: ChannelName.MYNTRA,
        logo: React.createElement(MyntraLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.FkBaAccountId,
                required: true,
                label: "BA Account ID",
                placeholder: "Enter BA account ID",
            },
            {
                id: ClientIntegrationFormFields.FkAaAccountId,
                required: true,
                label: "AA Account ID",
                placeholder: "Enter AA account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
        ],
        oauthEnabled: false,
    },
    25: {
        id: Channels.NYKAA,
        name: ChannelName.NYKAA,
        logo: React.createElement(NykaaLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    27: {
        id: Channels.BLINKIT,
        name: ChannelName.BLINKIT,
        logo: React.createElement(BlinkitLogo),
        color: "#EFBE10",
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
        ],
        oauthEnabled: false,
    },
    26: {
        id: Channels.BIGBASKET,
        name: ChannelName.BIGBASKET,
        logo: React.createElement(BigBasketLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    71: {
        id: Channels.DMART,
        name: ChannelName.DMART,
        logo: React.createElement(DMartLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    68: {
        id: Channels.JIO_MART,
        name: ChannelName.JIO_MART,
        logo: React.createElement(JioMartLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    65: {
        id: Channels.INSTAMART,
        name: ChannelName.INSTAMART,
        logo: React.createElement(SwiggyLogo),
        color: "#EFBE10",
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
        ],
        oauthEnabled: false,
    },
    2: {
        id: Channels.FLIPKART,
        name: ChannelName.FLIPKART,
        logo: React.createElement(FlipkartLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.FkBaAccountId,
                required: true,
                label: "BA Account ID",
                placeholder: "Enter BA account ID",
            },
            {
                id: ClientIntegrationFormFields.FkAaAccountId,
                required: true,
                label: "AA Account ID",
                placeholder: "Enter AA account ID",
            },
        ],
        oauthEnabled: false,
    },
    39: {
        id: Channels.FLIPKART_GROCERY,
        name: ChannelName.FLIPKART_GROCERY,
        logo: React.createElement(FlipkartLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.FkBaAccountId,
                required: true,
                label: "BA Account ID",
                placeholder: "Enter BA account ID",
            },
            {
                id: ClientIntegrationFormFields.FkAaAccountId,
                required: true,
                label: "AA Account ID",
                placeholder: "Enter AA account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
        ],
        oauthEnabled: false,
    },
    43: {
        id: Channels.CARREFOUR,
        name: ChannelName.CARREFOUR,
        logo: React.createElement(CarrefourLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
        ],
        oauthEnabled: false,
    },
    63: {
        id: Channels.PURPLLE,
        name: ChannelName.PURPLLE,
        logo: React.createElement(PurplleLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
        ],
        oauthEnabled: false,
    },
    87: {
        id: Channels.NOON,
        name: ChannelName.NOON,
        logo: React.createElement(NoonLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
        ],
        oauthEnabled: false,
    },
    283: {
        id: Channels.NOON_MINUTES,
        name: ChannelName.NOON_MINUTES,
        logo: React.createElement(NoonMinutesLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true }
        ],
        authFields: [
            { id: ClientIntegrationFormFields.UnqAccountId, required: true, label: 'Account ID', placeholder: 'Enter account ID' }
        ],
        oauthEnabled: false
    },
    109: {
        id: Channels.ZEPTO,
        name: ChannelName.ZEPTO,
        logo: React.createElement(ZeptoLogo),
        color: "#8B36FB",
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    118: {
        id: Channels.TAKEALOT,
        name: ChannelName.TAKEALOT,
        logo: React.createElement(TakealotLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
        ],
        oauthEnabled: false,
    },
    239: {
        id: Channels.TALABAT,
        name: ChannelName.TALABAT,
        logo: React.createElement(TalabatLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
        ],
        oauthEnabled: false,
    },
    42: {
        id: Channels.WALMART,
        name: ChannelName.WALMART,
        logo: React.createElement(WalmartLogo),
        accountTypes: [
            { type: ChannelIntegrationAccountType.Advertising, enabled: true },
        ],
        authFields: [
            {
                id: ClientIntegrationFormFields.UnqAccountId,
                required: true,
                label: "Account ID",
                placeholder: "Enter account ID",
            },
            {
                id: ClientIntegrationFormFields.AccountUsername,
                required: true,
                label: "Username",
                placeholder: "Enter username",
            },
            {
                id: ClientIntegrationFormFields.Password,
                required: true,
                label: "Password",
                placeholder: "Enter password",
            },
        ],
        oauthEnabled: false,
    },
    228: {
        id: Channels.TALABAT_REVSTACK,
        name: ChannelName.TALABAT,
        logo: React.createElement(TalabatLogo),
        accountTypes: [],
        authFields: [],
        oauthEnabled: false
    },
    30: {
        id: Channels.SHOPEE,
        name: ChannelName.SHOPEE,
        logo: React.createElement(ShopeeLogo),
        accountTypes: [],
        authFields: [],
        oauthEnabled: false
    },
    31: {
        id: Channels.LAZADA,
        name: ChannelName.LAZADA,
        logo: React.createElement(LazadaLogo),
        accountTypes: [],
        authFields: [],
        oauthEnabled: false
    },
    288: {
        id: Channels.TIKTOK,
        name: ChannelName.TIKTOK,
        logo: React.createElement(TiktokLogo),
        accountTypes: [],
        authFields: [],
        oauthEnabled: false
    },
    180: {
        id: Channels.HEPSIBURADA,
        name: ChannelName.HEPSIBURADA,
        logo: React.createElement(HepsiburadaLogo),
        accountTypes: [],
        authFields: [],
        oauthEnabled: false,
    },
};
